export default __webpack_public_path__ + "static/media/gallery-15.42bf46bb.jpg";